exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jumbo-panel[data-v-d06e0626]{background-color:#9aa098;padding:4rem 2rem;color:hsla(0,0%,100%,.7);padding:1rem;width:100%;margin-bottom:2rem}.jumbo-panel>.row[data-v-d06e0626]{margin:0 auto}.jumbo-panel>.header h1[data-v-d06e0626]{font-size:4.5rem;font-weight:300;line-height:1.2}@media screen and (min-width:576px){.jumbo-panel>.row[data-v-d06e0626]{width:100%}}@media screen and (min-width:768px){.jumbo-panel>.row[data-v-d06e0626]{width:100%}}@media screen and (min-width:992px){.jumbo-panel>.row[data-v-d06e0626]{width:70rem}}", ""]);

// exports
